/**
 * The chats screen: list and conversation.
 *
 * On a desktop these are two panes side by side, as in
 * docs/references/12-desktop-three-pane.png. On a phone they are two screens
 * — the list, and the conversation you pushed into — which is why the layout
 * needs to know whether a chat is open rather than just rendering both.
 *
 * Using a layout route rather than two sibling routes is what keeps the list
 * mounted while you move between conversations: its scroll position and its
 * subscription survive, instead of being torn down and refetched on every
 * click.
 */

import { Outlet, useParams } from 'react-router-dom'
import ChatList from '../components/chat/ChatList.jsx'
import './ChatsLayout.css'

export default function ChatsLayout () {
  const { chatId } = useParams()
  const hasOpenChat = Boolean(chatId)

  return (
    <div className={`cl${hasOpenChat ? ' cl--open' : ''}`}>
      <aside className="cl__list">
        <ChatList activeId={chatId} />
      </aside>

      <section className="cl__detail">
        <Outlet />
      </section>
    </div>
  )
}
